import { Component } from '@angular/core';
import { MatMiniFabButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ItemAttachmentCardComponent } from '../../item-attachment-card/item-attachment-card.component';

@Component({
  imports: [MatCardModule, MatIconModule, MatMiniFabButton],
  selector: 'app-quick-item-attachment-card',
  styleUrl: './quick-item-attachment-card.component.scss',
  templateUrl: './quick-item-attachment-card.component.html',
})
export class QuickItemAttachmentCardComponent extends ItemAttachmentCardComponent {}
